import { defineComponent } from 'vue';
import EventBus from '@/EventBus';

export default defineComponent({
  name: 'social-media',
  // mounted (){
  //   var element : any
  //   EventBus.on('my-falken-home', (evt : any) => {
  //     if (evt.eventContent == 'falkenContactUs') {
  //       element = document.getElementById("falkenContactUs");
  //       var team = element.offsetTop;
  //       window.scrollTo(0, team);
  //     }
  //   })
  // }
});